export default "__VITE_ASSET__dj9Ern$A__"